import React, { useState } from 'react';
import { array, string, bool, func } from 'prop-types';

import SvgIcon from '../../svg-icon/';
import { Tooltip } from '../../popovers';
import { theme } from '../../../styles/index';
import { ImageWrapper, Menu, MenuItem, MenuItemLink } from './styled-components';


export const SidebarMenu = ({
  data,
  collapsed,
  activeRoute,
  isOpenMobile,
  setIsOpenMobile,
}) => (
  <Menu>
    {data.map((item) => {
      const [tooltipVisible, setTooltipVisible] = useState(false);

      const menuItem = (
        <MenuItem
          key={item.text}
          activeItem={activeRoute.includes(item.url)}
          onClick={() => !activeRoute.includes(item.url) && setTooltipVisible(false)}
        >
          <MenuItemLink
            href={item.url}
            collapsed={collapsed}
            onClick={() => isOpenMobile && setIsOpenMobile(!isOpenMobile)}
          >
            <ImageWrapper
              collapsed={collapsed}
            >
              <SvgIcon
                {...item.icon}
                isWithoutHover
                fillOpacity={1}
                color={activeRoute.includes(item.url)
                  ? theme.colors.backgroundLightBlue
                  : theme.colors.backgroundDarkGray}
              />
            </ImageWrapper>
            {!collapsed && <span>{item.text}</span>}
          </MenuItemLink>
        </MenuItem>
      );

      return collapsed ?
        <Tooltip
          key={item.text}
          title={item.text}
          placement="right"
          destroyTooltipOnHide
          overlayClassName="sidebar-menu-tooltip"
          visible={tooltipVisible}
          onVisibleChange={setTooltipVisible}
        >
          {menuItem}
        </Tooltip>
        :
        menuItem;
    })}
  </Menu>
);

SidebarMenu.propTypes = {
  activeRoute: string,
  data: array.isRequired,
  collapsed: bool.isRequired,
  isOpenMobile: bool.isRequired,
  setIsOpenMobile: func.isRequired,
};

SidebarMenu.defaultProps = {
  activeRoute: '',
};



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-menu/index.js